<template>
  <div class="title">
    <div class="chatUser">
      <img
        class="avatar"
        v-if="currentSession === 'SYSTEM'"
        src="@/assets/img/im-icon/system-message.svg"
        style="
          width: 24px;
          height: 24px;
          border: 0.5px solid rgba(0, 0, 0, 0.1);
          border-radius: 50%;
        "
        alt=""
      />
      <fl-avatar class="avatar" v-else-if="!isGroup" :size="24" :src="singleMap[currentSession].avatar" :nickname="name" />
      <fl-avatar class="avatar" v-else :size="24" :src="teamsMap[currentSession].avatar" :nickname="teamsMap[currentSession].name" />
      <h3>
        <template v-if="isGroup">{{ teamsMap[currentSession].name }}</template>
        <template v-else>{{ name }}</template>
      </h3>
    </div>
    <button><img ref="chatboxClose" class="close" src="@/assets/img/chatbox/clear.svg" @click="close()" /></button>
  </div>
</template>

<script>
import mixinChathead from "@/im/components/mixins/chathead";

export default {
  mixins: [mixinChathead],
};
</script>

<style lang="scss" scoped>
.title {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  text-align: left;
  width: 100%;

  button {
    border: 0;
    height: 16px;
    outline: none;
    background: none;
    border-radius: 0;
    cursor: pointer;
  }

  .chatUser {
    flex: 1;
    height: 24px;
    display: flex;
    align-items: center;
    overflow: hidden;

    .avatar {
      margin-right: 12px;
    }

    h3 {
      font-size: 14px;
      font-weight: bold;
      color: #000;
      margin-right: 10px;
      font-weight: bold;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      flex: 1;
    }

    .status {
      padding: 4px 13px;
      font-size: 12px;
      font-weight: 500;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 10px;
      border-radius: 2px;
      font-weight: 500;
    }

    span {
      font-size: 14px;
      color: #7f8596;
      font-weight: normal;

      &:nth-of-type(1) {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 10px;
        border-right: 1px solid #e3e6ea;
      }
    }
  }

  /deep/ .toDetail {
    padding: 0;
    margin: 0;
    height: 20px;
    display: flex;
    align-items: center;

    > span {
      display: flex;
      align-items: center;
    }

    img:nth-of-type(1) {
      margin-right: 4px;
    }
  }
}
</style>
